import React, { useEffect, useRef } from 'react';

const StarsBackground = () => {
  const starsRef = useRef(null);

  useEffect(() => {
    const container = starsRef.current;
    if (!container) return;

    // Generate random stars
    const starCount = 60;
    for (let i = 0; i < starCount; i++) {
      const star = document.createElement('div');
      star.className = 'star';
      
      const size = Math.random() * 2 + 1;
      star.style.width = `${size}px`;
      star.style.height = `${size}px`;
      
      // Generate position, avoiding center text area only
      let left = Math.random() * 100;
      let top = Math.random() * 100;
      
      // Skip stars only around "Create winning ads with AI" text (30-70% horizontal, 30-50% vertical)
      // This keeps the text readable with space above and below
      if (left > 30 && left < 70 && top > 30 && top < 50) {
        // Move star to edges instead
        if (Math.random() > 0.5) {
          left = Math.random() * 30; // Left side
        } else {
          left = 70 + Math.random() * 30; // Right side
        }
      }
      
      star.style.left = `${left}%`;
      star.style.top = `${top}%`;
      star.style.animationDelay = `${Math.random() * 3}s`;
      star.style.animationDuration = `${Math.random() * 3 + 2}s`;
      
      container.appendChild(star);
    }

    // Generate shooting stars
    const createShootingStar = () => {
      const shootingStar = document.createElement('div');
      shootingStar.className = 'shooting-star';
      
      const width = Math.random() * 100 + 50;
      shootingStar.style.width = `${width}px`;
      shootingStar.style.left = `${Math.random() * 100}%`;
      shootingStar.style.top = `${Math.random() * 50}%`;
      shootingStar.style.animationDuration = `${Math.random() * 2 + 1}s`;
      
      container.appendChild(shootingStar);
      
      setTimeout(() => {
        shootingStar.remove();
      }, 3000);
    };

    // Create shooting stars periodically
    const shootingStarInterval = setInterval(createShootingStar, 8000);
    
    // Create initial shooting star
    createShootingStar();

    return () => {
      clearInterval(shootingStarInterval);
    };
  }, []);

  return <div ref={starsRef} className="stars-container" />;
};

export default StarsBackground;

